import { Config } from 'config/envConfig';
import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { alert, AlertType, Input } from '@quyva/shared-ui';
import { Brand } from './brand';
import { PoweredByInfo } from './powereByComponent';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faEnvelope,
    faLockOpen,
    faMailReply,
    faSpinner,
} from '@fortawesome/free-solid-svg-icons';
import { getUrl } from './pdfDisplay/utils';
import {
    Features,
    OtherFeatures,
    isEmailValid,
    isFeatureEnabled,
} from '@quyva/common';
import { useFeatureFlags } from '../context';

const ForgotPassword = () => {
    const { featureFlagsData } = useFeatureFlags();
    const [email, setEmail] = useState('');
    const [emailValid, setEmailValid] = useState(true);

    const [sendingMail, setSendingMail] = useState(false);
    const navigate = useNavigate();

    const handleSend = async (e) => {
        e.preventDefault();

        if (!isEmailValid(email)) {
            alert(AlertType.ERROR, 'Invalid email address!');
            setEmailValid(false);
            return;
        } else {
            setEmailValid(true);
        }

        setSendingMail(true);

        try {
            const dynamicUrl = getUrl(
                `http://${Config.NODE_SERVER_HOST}:${Config.NODE_SERVER_PORT}/register`
            );
            const res = await fetch(dynamicUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ email }),
            });

            if (!res.ok) {
                const errorData = await res.json();
                throw new Error(errorData.error || 'Failed to send email.');
            }

            // alert(AlertType.SUCCESS, 'Password reset link sent successfully!');
            navigate('/confirmation');
        } catch (error) {
            console.error('Error sending password reset link:', error);
            alert(
                AlertType.ERROR,
                error.message || 'An error occurred. Please try again.'
            );
        } finally {
            setSendingMail(false);
        }
    };

    return (
        <div className='flex items-center justify-center min-h-screen bg-gradient-primary'>
            <div className='w-full max-w-[500px] flex-col border bg-backgrounds-white p-6 shadow-lg rounded-xl'>
                <div className='mb-8 w-full lg:w-3/5 mx-auto'>
                    {isFeatureEnabled(
                        [Features.OTHERS, OtherFeatures.LOGO],
                        featureFlagsData
                    ) && <Brand iconClassName={'w-20 h-20 mr-3'} />}
                </div>
                <h2 className='text-xl font-semibold mb-4 text-center text-texts-secondary300'>
                    <FontAwesomeIcon icon={faLockOpen} className='mr-2' />
                    Reset Password
                </h2>
                <div className='text-sm mb-4 text-center text-texts-secondary300'>
                    Enter the email address associated with your account and
                    we'll send you a link to reset your password.
                </div>
                <form
                    onSubmit={handleSend}
                    className='flex flex-col text-sm w-full'
                >
                    <div className='mb-5'>
                        <Input
                            className={`rounded-xl border p-3 w-full hover:outline-none focus:outline-backgrounds-primary200 hover:border-backgrounds-primary200 shadow-sm ${
                                !emailValid && 'border-red-500'
                            }`}
                            type='email'
                            placeholder='Email Address'
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                        />
                    </div>

                    <button
                        className='flex w-full font-semibold items-center justify-center text-texts-primary bg-buttons-primary border border-1 shadow-inner hover:bg-gradient-buttons hover:border-buttons-primary hover:text-texts-primary p-3 mt-2 rounded-lg'
                        type='submit'
                        disabled={sendingMail}
                    >
                        {sendingMail ? (
                            <FontAwesomeIcon
                                icon={faSpinner}
                                className='animate-spin mr-1.5'
                            />
                        ) : (
                            <FontAwesomeIcon
                                icon={faEnvelope}
                                className='mr-1.5'
                            />
                        )}
                        <span className='drop-shadow-sm'>
                            {sendingMail ? 'Sending' : 'Send'}
                        </span>
                    </button>
                </form>
                <div className='mt-4 p-1 text-center text-sm font-semibold text-texts-tertiary hover:text-texts-tertiary400'>
                    <Link to='/login'>
                        <FontAwesomeIcon
                            icon={faMailReply}
                            className='mr-1.5'
                        />
                        Back to Login
                    </Link>
                </div>
                <div className='w-full flex justify-center items-center mt-8'>
                    <PoweredByInfo />
                </div>
            </div>
        </div>
    );
};

export default ForgotPassword;
